import { get, groupBy, keys } from 'lodash/fp';
import { createSelector } from 'reselect';
import { OrderItem } from '@mews-commander/types';
import { getStringProp, keyById } from '@mews/fp';
import { composeProps, createPropsExtender, DateTimeService } from '@mews/framework';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getServiceOrdersByIds } from '@mews-commander/legacy-entities/src/ducks';
import { getBillOrMonthOrderItems } from './orderItems';

const getOrderItemsGroupedByServiceOrderId = createSelector(
    getBillOrMonthOrderItems,
    groupBy<OrderItem>('serviceOrderId')
);

const getOrderItemsServiceOrderIds = createSelector(getOrderItemsGroupedByServiceOrderId, keys);

const getServiceOrdersByOrderItemIds = createSelector(
    composeProps(getServiceOrdersByIds, createPropsExtender('ids', getOrderItemsServiceOrderIds)),
    keyById
);

export const getOrderItemsGroupedByService = createSelector(
    getBillOrMonthOrderItems,
    getServiceOrdersByOrderItemIds,
    (orderItems, serviceOrdersByOrderItemIds) =>
        groupBy<OrderItem>(({ serviceOrderId }) => get([serviceOrderId, 'serviceId'], serviceOrdersByOrderItemIds))(
            orderItems
        )
);

export const getDateTimeFromMonth = createSelector(
    getStringProp('month'),
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (monthString: string, timezone: string) => DateTimeService.fromMonth(monthString, timezone)
);
